<template>
	<div class="knd-slider">
		<div class="knd-paragraaf">
      <slot name="media"></slot>
      <h3>Kies het juiste antwoord</h3>

      <blockquote class="knd-quote">
        {{ data.uitspraak }}
        <footer>{{ data.bron }}</footer>
      </blockquote>

      <div class="knd-vraag m-b-xxl">
        {{ question.vraag }}
      </div>

      <div class="knd-range-value-container m-b-xl">
        <div 
          v-for="(item, index) in customLabel(roundNumber).split(' ')"
          :key="index"
          class="knd-range-value"
          :style="`--scale: ${scale}; --rotate: ${-rotate}deg`"
        >
          <div
          >
            {{ item }}
          </div>
        </div>
      </div>

      <div class="knd-range-container m-b-xxl">

        <input 
          class="knd-range"
          type="range" 
          name="range"
          list="values"
          v-model="rangeValue" 
          min="0" 
          :disabled="answer.answered"
          :max="(question.opties.length -1) * 10"
          @input="changeSlider"
        />

        <div class="range-feedback" v-if="answer.answered">
          <RangeInput 
            :min="0"  
            :max="(question.opties.length -1) * 10"
            :value="correctIndex"
            :disabled="answer.answered"
            :customLabel="customLabel(correctIndex / 10)"
          />
        </div>

        <datalist id="values">
          <option value="0" :label="question.min"></option>
          <option :value="(question.opties.length -1) * 10" :label="question.max"></option>
        </datalist>
    </div>

      <div class="knd-btn-container" v-if="!answer.answered">
        <button @click="clickedBtn" class="knd-btn">
          Dit is mijn antwoord
        </button>
      </div>

      <Uitklap 
          :collapse="answer.answered"
          :correct="answer.correct"
          :feedback="data.feedback"
        />

		</div>
	</div>
</template>

<script>
import { toRefs, ref } from 'vue';
import { useStore } from 'vuex'
import Uitklap from '@/components/uitklap';
import RangeInput from '@/components/range';

export default {
	name: 'Slider',
  components: {Uitklap, RangeInput},
  props: {
      data: Object,
      question: Object,
      answer: Object
    },
  setup(props) {
		const store = useStore();
    const { data, question } = toRefs(props);

    let correctIndex = question.value.opties.findIndex(item => item.antwoord) * 10;

    const correct = ref(undefined);
    const scale = ref(1);

    // if localstorage get that answer;
    let storedAnswer = props.answer.answered ? props.answer.value : 0;

    let rangeValue = ref(storedAnswer * 10);
    let roundNumber = ref(storedAnswer);
    let rotate = ref(0);

    function customLabel(num) {
      if(question.value.opties[num]) {
        return question.value.opties[num].label;
      }

      return "";
    }

    const clickedBtn = () => {
      let optie = question.value.opties[roundNumber.value];
      
      correct.value = optie.antwoord ? true : false;

      store.dispatch('saveAnswer', 
      {
        id: data.value.id, 
        value: roundNumber.value, 
        correct: correct.value,
        answered: true 
      });
    }

    const changeSlider = (e) => {
      let num = +e.target.value;

      roundNumber.value = Math.round(num / 10);
      
      let scaledNum = (num / 100 * 2) + 1;
      scale.value = scaledNum;
      rotate.value = scaledNum;
    }

    return {
      roundNumber,
      rotate,
      rangeValue,
      scale,
      clickedBtn,
      correct,
      changeSlider,
      correctIndex,
      customLabel
    }

  },
	methods: {
	}
}
</script>


<style lang="scss">

  .knd-slider {
    background: linear-gradient(192.17deg, #FF5262 37.82%, #F4FFE7 96.84%);
    overflow-x: hidden;
  }

  datalist {
    display: flex;
    justify-content: space-between;
    color: #FFF;
    width: 100%;
  }

  .knd-range-container{
    position: relative;

    .range-feedback {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      pointer-events: none;

      input[type=range]::-webkit-slider-runnable-track {
        background-color: transparent;
        opacity: 0;
      }

      input[type="range"]::-webkit-slider-thumb {
        border-color: transparent;
        opacity: 0;
      }
      
      input[type=range]::-moz-range-thumb { 
        border-color: transparent;
        opacity: 0;
      }
    }
  }

  .knd-range-value-container {
    text-align: center;
    pointer-events: none;
    font-weight: bold;
    font-size: 1.4em;
    font-family: $font-header;
    
    :first-child {
        z-index: 10;
        position: relative;
      }

    .knd-range-value {
      color: #FFF;

      --offset: 0,0;
      --rotate: 0deg;
      --scale: 1;
      font-weight: 400;
      line-height: 1;
      padding: 0.125em 0.25em 0.25em;
      text-transform: uppercase;
      transform: translate(var(--offset)) rotate(var(--rotate)) scale(var(--scale));
      transition: .3s;
      
      div {
        border-radius: 3px;
        display: inline-block;
        background: $purple;
        padding: 6px 3px 0;
      }
    }
  }

  .knd-btn-container {
    text-align: center;
  }

/********** Range Input Styles **********/
/*Range Reset*/
input[type="range"] {
   -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
    width: 100%;
}

/* Removes default focus */
input[type="range"]:focus {
  outline: none;
}

/***** Chrome, Safari, Opera and Edge Chromium styles *****/
/* slider track */
input[type="range"]::-webkit-slider-runnable-track {
   background-color: #28006D;
   border-radius: 0.5rem;
   height: 10px;  
}

/* slider thumb */
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
   appearance: none;
   margin-top: -2.5rem; /* Centers thumb on the track */
}

input[type="range"] {

  &::-webkit-slider-thumb {
    /*custom styles*/
    background-color: $pale-pistachio;
    //  border: .5rem solid #28006D;
    height: 6rem;
    width: 6rem;
  
    background: url('~@/assets/icons/slider-thumb.png') no-repeat;
    background-size: contain;
    border-radius: 100%;
  
    transition: transform .2s ease-in-out;
  }

  &::-moz-range-thumb {
    /*custom styles*/
    background-color: $pale-pistachio;
    //  border: .5rem solid #28006D;
    height: 6rem;
    width: 6rem;

    background: url('~@/assets/icons/slider-thumb.png') no-repeat;
    background-size: contain;
    border-radius: 100%;

    transition: transform .2s ease-in-out;
  }

}

input[type="range"]:focus::-webkit-slider-thumb {   
  transform: scale(1.1);
}

/******** Firefox styles ********/
/* slider track */
input[type="range"]::-moz-range-track {
   background-color: #28006D;
   border-radius: 0.5rem;
   height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-moz-range-thumb {
   border: none; /*Removes extra border that FF applies*/
   border-radius: 0; /*Removes default border-radius that FF applies*/
}

input[type="range"]:focus::-moz-range-thumb {
  border: 1px solid #053a5f;
  outline: 3px solid #053a5f;
  outline-offset: 0.125rem; 
}



</style>